import { Youtube, Mail } from "lucide-react";

export const Concerts = () => (
  <section className="py-24 md:py-32 bg-[#FFD6C9]/40" data-testid="concerts-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-3 gap-8 items-stretch">
      <div className="lg:col-span-2 bg-white border-2 border-black rounded-3xl overflow-hidden shadow-brutal">
        <div className="aspect-[16/9] overflow-hidden border-b-2 border-black">
          <img
            src="/images/les-patates-au-beurre-en-concert.jpg"
            alt="Les Patates au Beurre"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="p-7">
          <span className="font-sans text-xs font-bold tracking-widest uppercase text-[#FF6B6B]">
            Duo · Reprises humoristiques
          </span>
          <h3 className="mt-2 font-display text-4xl md:text-5xl uppercase">Les Patates au Beurre</h3>
          <p className="mt-3 text-[#1a1a1a] leading-relaxed">
            Dauphine et Rissolée reprennent avec humour et velouté les tubes d'hier et d'aujourd'hui — guitare, ukulélé, beatbox et beaucoup de haha. Parfait pour soirées, festivals et événements associatifs.
          </p>
          <div className="mt-5 flex flex-wrap gap-3">
            <a
              href="https://www.youtube.com/@LesPTB"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-ptb-youtube"
              className="inline-flex items-center gap-2 bg-[#FF6B6B] text-white rounded-full px-5 py-2.5 font-sans font-bold text-sm border-2 border-black shadow-brutal-sm hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-none transition-all"
            >
              <Youtube size={16} /> Voir sur YouTube
            </a>
            <a
              href="mailto:ptbath@gmail.com?subject=Demande%20de%20booking%20-%20Les%20Patates%20au%20Beurre"
              data-testid="cta-ptb-booking"
              className="inline-flex items-center gap-2 bg-white text-black rounded-full px-5 py-2.5 font-sans font-bold text-sm border-2 border-black"
            >
              <Mail size={16} /> Réserver le duo
            </a>
          </div>
        </div>
      </div>

      <div className="bg-[#0A0A0A] text-white rounded-3xl p-6 md:p-7 flex flex-col justify-between border-2 border-black shadow-brutal">
        <div>
          <span className="font-sans text-[10px] font-bold tracking-widest uppercase text-[#FFD1DC]">
            Impro · Compagnies
          </span>
          <h3 className="mt-2 font-display text-3xl md:text-4xl uppercase leading-none">
            BIM & Cie
          </h3>
          <p className="mt-4 text-sm text-white/80 leading-relaxed">
            Loraine joue avec <strong>BIM</strong> et intervient comme{" "}
            <strong>coach impro</strong> à <strong>La Malice</strong> et <strong>BIM</strong>. Aussi avec Les Acides Animés, Impro 4 et Les Happy Cosmic Monkeys (Toulouse).
          </p>
        </div>
        <div className="mt-5 flex flex-wrap gap-1.5">
          {["La Malice", "BIM", "Acides Animés", "Impro 4", "Happy Cosmic Monkeys"].map((c) => (
            <div
              key={c}
              className="border border-white/20 rounded-full px-2.5 py-1 text-[10px] font-sans font-bold uppercase tracking-wider"
            >
              {c}
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
